if (!customElements.get('boogie-cart-count')) {
  customElements.define('boogie-cart-count', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const render = count => {
        if (Number.isInteger(count) && count >= 0) this.textContent = `(${count})`;
      };
      document.addEventListener('shopify:cart:lines-update', event => {
        event.promise?.then(({ cart, detail }) => {
          if (!detail?.didError) render(cart?.totalQuantity ?? detail?.itemCount);
        }).catch(() => {});
      }, { signal });
      window.addEventListener('pageshow', event => {
        if (!event.persisted || !this.dataset.cartUrl) return;
        fetch(this.dataset.cartUrl, { headers: { Accept: 'application/json' }, signal })
          .then(response => response.ok ? response.json() : null)
          .then(cart => render(cart?.item_count))
          .catch(() => {});
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
